import CreatePostFormV2 from './CreatePostFormV2';
export default CreatePostFormV2;
